firebird.factory('videoCanvasService', [
    '$interval',
    'logService',
    'configService',
    function ($interval, logService, configService) {
        var service = {
            initialize: initialize
        };

        var self;

        const logger = logService.createLoggerWithSource('[videoroomCtrl] videoCanvasService');

        return service;

        function initialize(selfParam) {
            self = selfParam;

            // video canvas related code. allow canvas filter and overlay.

            self.videoCanvas = false; // may be a string or null or boolean.
            self.videoCanvasData = {
                width: 640,
                height: 360,
                frameRate: 15,
                contentHint: null,

                videoStream: null,
                videoInput: null,
                canvasInput: null,
                canvasStream: null
            };

            self.initVideoCanvas = initVideoCanvas;
            self.startVideoCanvasStream = startVideoCanvasStream;
            self.stopVideoCanvasStream = stopVideoCanvasStream;
        }

        // enable from config
        function initVideoCanvas() {
            var videoCanvas = configService.getClientValue('videoCanvas');
            if (videoCanvas && videoCanvas != 'false') {
                self.videoCanvas = videoCanvas == 'true' ? true : videoCanvas;
            } else {
                self.videoCanvas = false;
            }
        }

        function startVideoCanvasStream(stream) {
            if (!self.videoCanvas) {
                return stream;
            }

            var data = self.videoCanvasData;

            if (self.videoCanvas) {
                self.videoCanvas.split(',').forEach(function (nv) {
                    var match = nv.match(/^(\w+):(\w+)$/);
                    if (match) {
                        var name = match[1],
                            value = match[2];
                        if (name == 'width' || name == 'height' || name == 'frameRate') {
                            data[name] = parseInt(value);
                        } else if (name == 'contentHint') {
                            data[name] = value;
                        }
                    }
                });
            }

            if (!data.canvasStream) {
                var canvasInput = (data.canvasInput = document.createElement('canvas'));
                var videoInput = (data.videoInput = document.createElement('video'));
                videoInput.width = canvasInput.width = data.width;
                videoInput.height = canvasInput.height = data.height;
                videoInput.setAttribute('autoplay', true);
                videoInput.setAttribute('muted', true);

                data.canvasStream = canvasInput.captureStream();
                if (data.contentHint) {
                    data.canvasStream.getVideoTracks()[0].contentHint = data.contentHint;
                }
            }

            if ((self.videoCanvas || '').match(/\bstream:dummy\b/)) {
                data.videoStream = null;
            } else if (!stream) {
                var media = self.getMediaConstraints('video-filter');
                if (media.video) {
                    media.video.frameRate = Math.min(media.video.frameRate || 30, data.frameRate);
                    media.video.width = Math.min(media.video.width || 1280, data.width);
                    media.video.height = Math.min(media.video.height || 720, data.height);
                }
                logger.log('videoroomCtrl - videoCanvas - getUserMedia with constraints ' + JSON.stringify(media));
                navigator.mediaDevices
                    .getUserMedia(media)
                    .then(function (stream) {
                        var data = self.videoCanvasData;
                        data.videoStream = stream;
                        stream.getVideoTracks()[0].contentHint = 'motion';
                        data.videoInput.srcObject = stream;
                    })
                    .catch(function (err) {
                        logger.error('startVideoCanvasStream', 'failed to get user media for video canvas', err);
                    });
            } else {
                data.videoStream = stream;
                data.videoInput.srcObject = stream;
            }

            if (!data.interval) {
                var items = [];
                var previous = '';
                var start = Date.now();
                var bgcolor = null;

                data.interval = $interval(function () {
                    var data = self.videoCanvasData;
                    // update items if self.videoCanvas changes or for first time.
                    if (typeof self.videoCanvas === 'string') {
                        if (self.videoCanvas != previous) {
                            // changed
                            previous = self.videoCanvas;
                            if (items.length > 0) {
                                items.splice(0, items.length);
                            }
                            self.videoCanvas.split(',').forEach(function (nv) {
                                var index = nv.indexOf(':');
                                if (index >= 0) {
                                    items[nv.substring(0, index)] = nv.substring(index + 1);
                                } else {
                                    items[nv] = true;
                                }
                            });

                            if (!items.bgcolor) {
                                bgcolor = '';
                            } else if (items.bgcolor == 'random') {
                                bgcolor =
                                    'rgb(' +
                                    Math.floor(Math.random() * 256) +
                                    ',' +
                                    Math.floor(Math.random() * 192) +
                                    ',' +
                                    Math.floor(Math.random() * 192) +
                                    ')';
                            } else if (items.bgcolor.match(/^([a-z]+)|([A-F0-9]+)$/)) {
                                bgcolor = items.bgcolor;
                            }
                        }
                    } else if (items.length > 0) {
                        // clear items
                        items.splice(0, items.length);
                        bgcolor = '';
                    }

                    var ctx1 = data.canvasInput.getContext('2d');
                    if (items.filter) {
                        ctx1.filter = items.filter;
                    }

                    if (items.stream != 'dummy') {
                        if (data.videoInput && data.videoInput.videoWidth && data.videoInput.videoHeight) {
                            ctx1.drawImage(
                                data.videoInput,
                                0,
                                0,
                                data.videoInput.videoWidth,
                                data.videoInput.videoHeight,
                                0,
                                0,
                                data.width,
                                data.height
                            );
                        }
                    } else {
                        var label = '' + Math.round((Date.now() - start) / 100);
                        label = label.substring(0, label.length - 1) + '.' + label.substring(label.length - 1);

                        ctx1.clearRect(0, 0, data.width, data.height);
                        if (bgcolor) {
                            ctx1.fillStyle = bgcolor;
                            ctx1.fillRect(0, 0, data.width, data.height);
                            ctx1.fillStyle = 'none';
                        }
                        ctx1.font = '60pt Helvetica';
                        ctx1.textAlign = 'center';
                        ctx1.textBaseline = 'middle';
                        ctx1.fillStyle = 'white';
                        ctx1.strokeStyle = 'black';
                        ctx1.shadowBlur = 20;
                        ctx1.shadowOffsetX = ctx1.shadowOffsetY = 0;
                        ctx1.shadowColor = 'rgba(0,0,0,0.8)';
                        ctx1.fillText(label, data.width / 2, data.height / 2);
                        ctx1.shadowBlur = 'none';
                        ctx1.shadowColor = 'none';
                    }

                    if (items.filter) {
                        ctx1.filter = 'none';
                    }
                    if (items.caption) {
                        var text = items.caption.replace(/\{name\}/g, self.name || 'Anonymous');
                        ctx1.font = '18pt Helvetica';
                        ctx1.textAlign = 'center';
                        ctx1.textBaseline = 'bottom';
                        ctx1.fillStyle = 'white';
                        ctx1.shadowBlur = 10;
                        ctx1.shadowOffsetX = ctx1.shadowOffsetY = 0;
                        ctx1.shadowColor = 'rgba(0,0,0,0.8)';
                        ctx1.fillText(text, data.width / 2, data.height - 10, 640);
                        ctx1.shadowBlur = 'none';
                        ctx1.shadowColor = 'none';
                    }
                }, Math.round(1000 / data.frameRate));
            }

            return data.canvasStream.clone();
        }

        function stopVideoCanvasStream() {
            logger.log('stopVideoCanvasStream...');
            var data = self.videoCanvasData;
            if (data.interval) {
                $interval.cancel(data.interval);
                data.interval = null;
            }
            if (data.videoInput) {
                data.videoInput.srcObject = null;
                data.videoInput = null;
            }
            if (data.canvasStream) {
                try {
                    data.canvasStream.getVideoTracks()[0].stop();
                } catch (e) {}
                data.canvasStream = null;
            }
            if (data.videoStream) {
                try {
                    data.videoStream.getVideoTracks()[0].stop();
                } catch (e) {}
                data.videoStream = null;
            }
            if (data.canvasInput) {
                data.canvasInput = null;
            }
        }
    }
]);
